import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { jsx as _jsx } from "react/jsx-runtime";
const AsyncCitationPanelContent = Loadable({
  loader: () => import('./CitationPanelContentContainer')
});
export const preloadSmartPropertyCitationPanel = async () => {
  await AsyncCitationPanelContent.preload();
};
export const SmartPropertyCitationPanel = props => {
  return /*#__PURE__*/_jsx(AsyncCitationPanelContent, Object.assign({}, props));
};